module.exports = __webpack_public_path__ + "img/logo-mercury.e2a7664b.svg";